module.exports = "<div class=\"noData jumbotron\">\n    <p>No measurements...</p>\n    <p>Please change filtering criteria.</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/noData/noData.html
// module id = 782
// module chunks = 0